import React, { useState } from "react";
import { Box, IconButton, Tooltip } from "@mui/material";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import ReactMarkdown from "react-markdown";

const AssistantMessage = ({ message, setShowExcerpts, showExcerpts, setExpandedFileRefId }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(message);
    setIsCopied(true);

    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  const renderers = {
    a: ({ href, children }) => {
      const isRefLink = href.startsWith("#ref-");
      const fileRefId = isRefLink ? href.replace("#ref-", "") : null;

      const handleClick = (e) => {
        e.preventDefault();
        if (!showExcerpts) {
          setShowExcerpts(true)
        }
        if (fileRefId && setExpandedFileRefId) {
          setExpandedFileRefId(fileRefId);
        }
      };

  return (
    <Box
      component="a"
      href={href}
      onClick={isRefLink ? handleClick : undefined}
      sx={{
        backgroundColor: '#f0f0f0',
        borderRadius: '4px',
        padding: '2px 6px',
        fontSize: '0.875rem',
        color: 'black',
        textDecoration: 'none',
        display: 'inline-block',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        '&:hover': {
          backgroundColor: '#e0e0e0',
          textDecoration: 'underline',
          color: '#1976d2', // optional: add slight color on hover
        },
      }}
    >
      {children}
    </Box>
  )}};

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      sx={{
        width: "100%",
        marginBottom: "10px",
      }}
    >
      <Box
        display="flex"
        alignItems="flex-start"
        justifyContent="flex-start"
        sx={{
          width: "100%",
        }}
      >
        <Box
          margin={1}
          sx={{
            borderRadius: "50%",
            border: "1px solid #343D3F",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: { xs: "40px" },
            height: { xs: "40px" },
            boxShadow: "0px 2px 2px rgba(0, 0, 0, 0.25)",
          }}
        >
          <SmartToyOutlinedIcon sx={{ padding: "15px" }} />
        </Box>

        <Box
          sx={{
            fontSize: {
              xs: "14px",
              sm: "15px",
              md: "16px",
            },
            fontFamily:
              "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
            maxWidth: "100%",
            wordBreak: "break-word",
            lineHeight: "1.5",
            "& h1": {
              fontSize: {
                xs: "18px",
                md: "20px",
              },
              marginBottom: "8px",
            },
            "& h2": {
              fontSize: {
                xs: "16px",
                md: "18px",
              },
              marginBottom: "6px",
            },
            "& p": {
              marginBottom: "10px",
            },
            "& ul": {
              paddingLeft: "20px",
              marginBottom: "10px",
            },
            "& li": {
              marginBottom: "4px",
            },
          }}
        >
          <ReactMarkdown components={renderers}>{message}</ReactMarkdown>
        </Box>
      </Box>
      <Box
        display="flex"
        justifyContent="flex-end"
        sx={{
          width: "100%",
          marginTop: "8px",
        }}
      >
        <Tooltip title={isCopied ? "Copied!" : "Copy"}>
          <IconButton onClick={handleCopy} size="small">
            <ContentCopyIcon fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};

export default AssistantMessage;
